<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="formData"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SitesettingsEdit extends Vue {

  data = {}

  get formData() {
    return this.data;
  }

  get columns() {
    return [
      {
        prop: 'order_notification_emails',
        label: '订单情况通知邮箱',
        form: {
          component: 'input',
          props: {
            hint: '多个邮箱用分号隔开，分号不区分中英文'
          }
        }
      },
      {
        prop: 'wechat_settlement_emails',
        label: '微信提现通知邮箱',
        form: {
          component: 'input',
          props: {
            hint: '多个邮箱用分号隔开，分号不区分中英文'
          }
        }
      },
      {
        prop: 'express_base_fee',
        label: '邮费',
        form: {
          component: 'inputNumber'
        }
      },
      {
        prop: 'order_amount_in_express_free',
        label: '免邮订单金额',
        form: {
          component: 'inputNumber'
        }
      },
      {
        prop: 'refund_name',
        label: '退货收货人名字',
        form: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'refund_phone',
        label: '退货联系电话',
        form: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'refund_address',
        label: '退货地址',
        form: {
          component: 'input',
          required: true,
          props: {
            hint: '修改退货联系人/地址后需到阿里云服务后台新增模板，并通知开发人员更改模板CODE'
          }
        }
      },
      {
        prop: 'custom_service_wechat_account',
        label: '客服微信号',
        form: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'custom_service_cover',
        label: '客服微信图片',
        form: {
          component: 'upload',
          required: true,
          props: {
            hint: '图片建议尺寸520:650'
          }
        }
      },
      {
        prop: 'personal_page_background_cover',
        label: '个人中心页背景图',
        renderCell: {
          type: 'image',
          width: '150px',
          height: 'auto'
        },
        form: {
          component: 'upload',
          required: true
        }
      },
      {
        prop: 'home_page_share_word',
        label: '首页分享卡片分享语',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'home_page_share_covers',
        label: '首页分享卡片图',
        form: {
          component: 'upload',
          required: true,
          props: {
            limit: 10,
            hint: '可传多张，建议尺寸420:340'
          }
        }
      },
      {
        prop: 'home_page_share_background_covers',
        label: '首页分享海报图',
        form: {
          component: 'upload',
          required: true,
          props: {
            limit: 10,
            hint: '可传多张，建议尺寸565:630'
          }
        }
      },
      {
        prop: 'home_page_popup_cover',
        label: '首页弹窗',
        form: {
          component: 'upload',
          props: {
            hint: '没传图片则首页不显示弹窗'
          }
        }
      },
    ];
  }

  async mounted() {
    this.data = await this.$request.get('/site_settings');
  }

  async handleUpdate(data) {
    await this.$request.put('/site_settings', data);
    this.$message.success('更新成功');
    this.$router.push({ name: 'site_settings.index' });
  }
}
</script>
